import { render, staticRenderFns } from "./page-meta.vue?vue&type=template&id=0dccd748&scoped=true&"
import script from "./page-meta.ts?vue&type=script&lang=ts&"
export * from "./page-meta.ts?vue&type=script&lang=ts&"
import style0 from "./page-meta.scss?vue&type=style&index=0&id=0dccd748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dccd748",
  null
  
)

export default component.exports